<template>
    <div class="workorderInfromation_file">
        <!--<div class="workorderInfromation_file_list" v-for="item in files">-->
            <!--<div>-->
                <!--<img v-if="item.fileImg=='1'" class="workorderInfromation_file_icon" src="../../assets/images/ico_pdf.png" alt="">-->
                <!--<img v-else-if="item.fileImg=='2'" class="workorderInfromation_file_icon" src="../../assets/images/ico_word.png" alt="">-->
                <!--<img v-else-if="item.fileImg=='3'" class="workorderInfromation_file_icon" src="../../assets/images/ico_excel.png" alt="">-->
                <!--<img v-else-if="item.fileImg=='4'" class="workorderInfromation_file_icon" src="../../assets/images/ico_tp.png" alt="">-->
                <!--<img v-else-if="item.fileImg=='5'" class="workorderInfromation_file_icon" src="../../assets/images/ico_yp.png" alt="">-->
                <!--<img v-else-if="item.fileImg=='6'" class="workorderInfromation_file_icon" src="../../assets/images/ico_other.png" alt="">-->
                <!--<img v-else class="workorderInfromation_file_icon" src="../../assets/images/ico_other.png" alt="">-->
                <!--<span class="workorderInfromation_file_name">{{item.fileName}}</span>-->
                <!--<span class="workorderInfromation_file_size">{{item.fileSizeShow}}</span>-->
            <!--</div>-->
            <!--<div>-->
                <!--<el-icon @click="handleFilePreview(item)"><View /></el-icon>-->
                <!--<el-icon @click="handleFileDownload(item)"><download /></el-icon>-->
            <!--</div>-->
        <!--</div>-->
        <div class="Jsjb_file" >
            <div class="file_list">
                <div class="file_list_img" >
                    <div class="file_list_img_item"  v-for="(item,index) in imgFileList">
                        <img :src="item.src" alt="">
                        <div class="file_list_img_modal">
                            <i class="icon-eye_line" @click="handleImgPreview(imgFileList,item,index)"></i>
                            <i class="icon-download_2_line" @click="handleFileDownload(item)"></i>
                        </div>
                    </div>
                </div>
                <div class="file_list_img" >
                    <div class="file_list_img_item" v-for="(item,index) in radioFileList">
                        <img src="../../assets/images/radioImg.png" alt="">
                        <div class="file_list_img_modal">
                            <i class="icon-eye_line" @click="handleFilePreview(item)"></i>
                            <i class="icon-download_2_line" @click="handleFileDownload(item)"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ImgCarousel  ref="imgCarouselChild" :imgList="imgList" :zoom-rate="1.2" :imgListIndex="imgListIndex"></ImgCarousel>
</template>

<script>
    import {watch, ref,getCurrentInstance} from 'vue'
    import {filePreview,fileDownload} from '../../assets/js/base.js';
    import ImgCarousel from '@/components/ImgCarousel/ImgCarousel.vue';

    export default {
        name: "TimeLine_file",
        props: ["files"],
        components: {ImgCarousel},
        setup(props, context){
            const {proxy} = getCurrentInstance();
            const files = ref(props.files);
            let imgFileList = ref([])
            let radioFileList = ref([])
            let imgCarouselChild = ref()
            //文件查看
            const handleFilePreview=(param)=>{
                // proxy.$axios.get("/jgfast/sys/comm/fileUploadView", {
                //     fileId:param.fileId
                // }).then((res) => {
                // });
                filePreview(param.fileName,param.fileId)
            }
            //文件下载
            const handleFileDownload =(param)=>{
                // proxy.$axios.get("/jgfast/sys/comm/download", {
                //     fileId:param.fileId
                // }).then((res) => {
                // });
                fileDownload(param.fileId)
            }
            watch(()=>props.files,(newVal)=>{
                newVal.map(item=>{
                    if(item.fileImg==4){
                        item.src = "/jgfast/sys/comm/fileUploadView?fileId="+item.fileId
                        imgFileList.value.push(item)
                    }else if(item.fileImg==6){
                        radioFileList.value.push(item)
                    }
                })
            },{
                immediate:true
            })
            let imgListIndex = ref(0)
            let imgList = ref([])
            const handleImgPreview = (param,item,index)=>{
                imgListIndex.value = index;
                imgList.value = param;
                imgCarouselChild.value.showImgCarousel()
            }
            return{
                files,
                handleFilePreview,
                handleFileDownload,
                imgFileList,
                radioFileList,
                handleImgPreview,
                imgListIndex,
                imgList,
                imgCarouselChild
            }
        }
    }
</script>

<style scoped>

</style>
